"use client"

import { productActions } from "@/lib/redux/features/product/reduce"
import { useAppDispatch, useAppSelector } from "../redux"

export const useSelectedAspect = () => {
  const selectedAspectLabel = useAppSelector(state => state.product.productDetailState.selectedAspectLabel)
  const bundle = useAppSelector(state => state.product.design_detail.data?.bundle)
  const aspects = useAppSelector(state => state.product.design_detail.data.aspects)
  const dispatch = useAppDispatch()

  const onSelectAspect = (aspectLabel: string) => {
    dispatch(productActions.selectAspectLabel(aspectLabel))
  }

  return {
    aspect: bundle ? null : Object.values(aspects).find((a) => {
      return a.aspect_group_label === selectedAspectLabel || a.label === selectedAspectLabel
    }),
    onSelect: onSelectAspect
  }
}